module.exports = __webpack_public_path__ + "img/hest4.83066632.jpg";